import { render, staticRenderFns } from "./PRIL.vue?vue&type=template&id=32766126&scoped=true&"
import script from "./PRIL.vue?vue&type=script&lang=ts&"
export * from "./PRIL.vue?vue&type=script&lang=ts&"
import style0 from "./PRIL.vue?vue&type=style&index=0&id=32766126&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32766126",
  null
  
)

export default component.exports